import React, { useMemo, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Switch,
  Text,
  Link,
  useColorModeValue,
} from "@chakra-ui/react";

import signInImage from "assets/img/signInImage1.png";
import AuthService from "services/auth/authService";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const authService = useMemo(() => new AuthService(), []);

  const [showLoginSuccess, setShowLoginSuccess] = useState(false);
  const [showLoginFailed, setShowLoginFailed] = useState(false);
  const [loading, setLoading] = useState(false);

  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");

 const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await authService.login(username, password);

    // Jika berhasil (200 OK)
    if (res.status === 200 && res.data.token) {
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.user.ROLE);
      localStorage.setItem("nama", res.data.user.NAMA);
      localStorage.setItem("kd_unit", res.data.user.ID);
      localStorage.setItem("nip", res.data.user.NIP);
      localStorage.setItem("expired", new Date().getTime() + 2 * 60 * 60 * 1000);

      setShowLoginSuccess(true);
      setTimeout(() => navigate("/admin/dashboard"), 1500);
    } else {
   
      setShowLoginFailed(true);
    }
  } catch (error) {

    console.error("Login Error:", error);
    setShowLoginFailed(true);
  } finally {
    setLoading(false);
  }
};

  return (
    <Flex position="relative" mb="40px">
      <Flex
        h={{ sm: "initial", md: "75vh", lg: "85vh" }}
        w="100%"
        maxW="1044px"
        mx="auto"
        justifyContent="space-between"
        mb="30px"
        pt={{ sm: "100px", md: "0px" }}
      >
        {/* Form Login */}
        <Flex
          alignItems="center"
          justifyContent="start"
          w={{ base: "100%", md: "50%", lg: "42%" }}
        >
          <Flex direction="column" w="100%" p="48px" mt={{ md: "100px" }}>
            <Heading color={titleColor} fontSize="32px" mb="10px">
              Welcome Back
            </Heading>

            <form onSubmit={handleLogin}>
              <FormControl>
                <FormLabel fontSize="sm">Username / NIP</FormLabel>
                <Input
                  borderRadius="15px"
                  mb="24px"
                  fontSize="sm"
                  type="text"
                  placeholder="Masukkan Username / NIP"
                  size="lg"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />

                <FormLabel fontSize="sm">Password</FormLabel>
                <Input
                  borderRadius="15px"
                  mb="36px"
                  fontSize="sm"
                  type="password"
                  placeholder="Masukkan Password"
                  size="lg"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                <FormControl display="flex" alignItems="center">
                  <Switch id="remember-login" colorScheme="teal" me="10px" />
                  <FormLabel htmlFor="remember-login" mb="0" ms="1" fontWeight="normal">
                    Remember me
                  </FormLabel>
                </FormControl>

                <Button
                  fontSize="10px"
                  type="submit"
                  bg="teal.300"
                  w="100%"
                  h="45"
                  mb="20px"
                  color="white"
                  mt="20px"
                  isLoading={loading}
                  loadingText="Signing In..."
                  _hover={{ bg: "teal.200" }}
                  _active={{ bg: "teal.400" }}
                >
                  SIGN IN
                </Button>
              </FormControl>
            </form>

            <Flex flexDirection="column" alignItems="center" mt="10px">
              <Text color={textColor} fontWeight="medium">
                Don't have an account?
                <Link color={titleColor} as="span" ms="5px" fontWeight="bold">
                  Sign Up
                </Link>
              </Text>
            </Flex>
          </Flex>
        </Flex>

        {/* Background Image */}
        <Box
          display={{ base: "none", md: "block" }}
          overflowX="hidden"
          h="100%"
          w="40vw"
          position="absolute"
          right="0px"
        >
          <Box
            bgImage={signInImage}
            w="100%"
            h="100%"
            bgSize="cover"
            bgPosition="50%"
            position="absolute"
            borderBottomLeftRadius="20px"
          ></Box>
        </Box>
      </Flex>

      {/* Alerts */}
      {showLoginSuccess && (
        <SweetAlert
          success
          title="Login Berhasil!"
          onConfirm={() => setShowLoginSuccess(false)}
        >
          Selamat datang kembali 🎉
        </SweetAlert>
      )}

      {showLoginFailed && (
        <SweetAlert
          danger
          title="Login Gagal!"
          onConfirm={() => setShowLoginFailed(false)}
        >
          Username atau password salah.
        </SweetAlert>
      )}
    </Flex>
  );
};

export default SignIn;
